<template>
    <div class="step_content">
        <div class="operation_wrapper">
            <span class="step_icon border_leftT"></span>
            <span class="step_icon border_rightT"></span>
            <span class="step_icon border_leftB"></span>
            <span class="step_icon border_rightB"></span>
            <el-form ref="form"
                     :model="form"
                     :rules='rules'
                     label-width="250px"
                     class="form">
                    <el-row>
                        <el-scrollbar :style="{'height':cardMinHeight,'min-height':'200','width':'100%'}">
                            <el-col :span="24">
                                <el-form-item label="监督检查单位：" prop='supervisionIds' style="width:100%;">
                                    <!-- <el-select v-model="form.supervisionIds" :popper-append-to-body="false" filterable multiple clearable :disabled="historyid == 0" value-key="id" style="width:100%;color: #3196FA;background: inherit">
                                        <el-option v-for="(item,index) in orgSelectList"
                                                   :key="index"
                                                   :label="item.name"
                                                   :value="item.id"></el-option>
                                    </el-select> -->
                                    <select-depart-tree 
                                        :selectDisabled="historyid == 0"
                                        ref="selectDepartTreeRef"
                                        :modelValue.sync="form.supervisionIds"  
                                        :isMultiple="true" 
                                        @handleDeptType="(val)=>changeDept(val,'5')" >
                                    </select-depart-tree>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="请输入任务名称：" prop='workName' style="width:100%;">
                                    <el-input type="textarea"
                                              :autosize="{ minRows: 3}"
                                              v-model="form.workName"
                                              maxlength="200" :disabled="historyid == 0"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-scrollbar>
                    </el-row>
            </el-form>
        </div>

        <div class="btn_wraper" style="text-align: center">
            <el-button type="primary" plain @click="nextStep()">下一步</el-button>
        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    // import {removeTabHandle} from '@/utils/routeTab';
import selectDepartTree from "@/views/modules/components/selectDepartTree"

    export default {
        name: "step_one",
        components: {
            selectDepartTree
        },
        props:{
            activeStep: {type: Number, default: 1},
            curStep: {type: Number, default: 1},
            historyid: {type: Number, default: -1},
            taskName: {type: String, default: ''},
            supervisionIdsName: {type: String, default: ''},
        },
        data(){
            return{
                id:"",
                cardMinHeight: document.documentElement.clientHeight - 600  + 'px',
                agencyColumns:[{name: 'tenderAgencyName', title: '代理机构名称'}, {name: 'tenderAgencyCode', title: '代理机构编号'}],
                orgSelectList:[],
                formDataString:'',
                form:{
                    id:'',
                    supervisionIds:[],
                    workName:""
                },
                rules: {
                    supervisionIds: [{required: true, message: '请选择监督检查单位', trigger: 'change'}],
                    workName: [{required: true, message: '请输入任务名称', trigger: 'blur'}],
                },
            }
        },
        filters:{

        },
        created(){
            this.form.id = this.$route.query.id;
            this.getDataById();
            this.getOrgSelectList();
            this.$nextTick(()=>{
                //取消验证
               this.$refs.form.clearValidate('supervisionIds'); 
            })
        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            })
        },
        mounted() {

        },
        methods:{
            changeDept(val,flag){
                this.form.supervisionIds=[]
                    if(flag=='5'){
                        val.forEach((item)=>{
                            if( item.type!=="region"){
                              this.form.supervisionIds.push(item.id)
                            }
                        })
                    }
            },
            getDeptInfo(){
                this.$httpReq.get('/configs/sysexectormanage/listUserOrg').then(res=>{
                    if(res.data.code == '1' &&  res.data.data && res.data.data.length > 0 && this.form.supervisionIds.length == 0){
                        let resData = res.data.data || [];
                        const _this = this;
                        resData.forEach((item)=>{
                            if(item.isMaster && item.orgId)_this.form.supervisionIds.push(item.deptId)
                        })
                    }
                })
            },
            getOrgSelectList(){

                this.$httpReq.get('/projectDoubleExtract/extracttask/getDepartments').then(res=>{
                    if(res.data.code == '1'){
                        let resData = res.data.data || [];
                        let dataArr = [];
                        resData.forEach((item)=>{
                            dataArr.push(item.data)
                        })
                        this.orgSelectList = dataArr;
                        return
                    }

                })
            },
            getDataById(){

                if(this.form.id){
                    this.$httpReq.get('/projectDoubleExtract/extracttask/get?id='+this.form.id).then(res=>{
                        if(res.data.code == '1'){
                            this.form = {...res.data.data}
                            this.form.supervisionIds = res.data.data.supervisionIds.split(",");
                            this.formDataString = JSON.stringify(this.form);
                            return
                        }
                        this.$message.error(res.data.msg)
                    })
                }else{
                    this.form = {
                        id:'',
                        supervisionIds:[],
                        workName:""
                    }
                    this.getDeptInfo();
                }


            },

            prevStep(){
                this.$emit("update:activeStep",this.activeStep - 1)
            },
            nextStep(){

                if(this.form.supervisionIds.length > 20){
                    this.$message.error('监督检查单位个数不能超过20个。')
                    return
                }

                if(this.formDataString == JSON.stringify(this.form)){

                    this.$emit("update:activeStep",this.activeStep + 1)

                }else{
                    this.$refs['form'].validate((valid) => {
                        if (valid) {

                            let params = JSON.parse(JSON.stringify(this.form))
                            params.supervisionIds = params.supervisionIds.join(",")
                            this.$httpReq({
                                url: '/projectDoubleExtract/extracttask/save',
                                method: 'post',
                                data:params
                            }).then(({data}) => {
                                if (data && data.code === '1') {
                                    this.$emit("update:activeStep",this.activeStep + 1);
                                    this.$emit("upDateTaskInfo",data.data.id);
                                    removeTabHandle('project_extract_detail');
                                    this.$router.push({
                                        name:'project_extract_detail',
                                        query:{
                                            id:data.data.id,
                                        }
                                    })
                                }else{
                                    this.$message({
                                        type:'error',
                                        message:data.msg
                                    })

                                }
                            })

                        }
                    })
                }





            },


        },
    }
</script>

<style lang="scss" scoped>
    .step_content{
        .operation_wrapper{
            width:100%;
            padding-right: 16px;
            position: relative;

            /deep/ .el-textarea__inner::-webkit-scrollbar {
                width:17px;
            }
            /* 滚动槽 */
            /deep/ .el-textarea__inner::-webkit-scrollbar-track {
                -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
            }
            /* 滚动条滑块 */
            /deep/ .el-textarea__inner::-webkit-scrollbar-thumb {
                background:rgba(49,150,250,0.7);
            }
            /* 滚动条的轨道的两端按钮 */
            /deep/ .el-textarea__inner::-webkit-scrollbar-button {
                background:rgba(49,150,250,0.7);
            }
            /* 滚动条的内层轨道 */
            /deep/ .el-textarea__inner::-webkit-scrollbar-track-piece {
                background:rgba(49,150,250,0.7);
            }
            /* 滚动条的边角 */
            /deep/ .el-textarea__inner::-webkit-scrollbar-corner {
                background:rgba(49,150,250,0.7);
            }
            /* 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件 */
            /deep/ .el-textarea__inner::-webkit-resizer {
                background:rgba(49,150,250,0.1);
            }
            /deep/ .el-textarea__inner::-webkit-scrollbar-thumb:window-inactive {
                background:rgba(49,150,250,0.7);
            }



        }
    }





</style>